import { render, staticRenderFns } from "./shipList.vue?vue&type=template&id=50ecd6f5&scoped=true"
import script from "./shipList.vue?vue&type=script&lang=js"
export * from "./shipList.vue?vue&type=script&lang=js"
import style0 from "./shipList.vue?vue&type=style&index=0&id=50ecd6f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ecd6f5",
  null
  
)

export default component.exports